import * as PageBreakWidget from './pagebreak';
import * as TextWidget from './text';
import * as TitleWidget from './title';

export {
    PageBreakWidget,
    TextWidget,
    TitleWidget,
};


// WEBPACK FOOTER //
// ./src/components/widget/basic/index.ts